import { EarningMechanismPointSpendInput } from '@occc/graphql';
import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { isFieldDirty } from '@occc-app/offerHelpers/utils';
import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';
import { makeEarningMechanismCreateOperation } from '@occc-app/offerHelpers/operations/earningMechanism';
import { awardInputCreator } from '@occc-app/offerHelpers/awardInputCreator';
import { earningMechanismInputCreator } from '@occc-app/offerHelpers/earningMechanismInputCreator';

import { ConfigureFormValues } from '../../../types';

type GetPointSpendCreateInput = (
  values: Pick<ConfigureFormValues, 'pointSpend' | 'awardVouchers' | 'isOfferReturnable'>,
) => { pointSpend: EarningMechanismPointSpendInput };

const getPointSpendCreateInput: GetPointSpendCreateInput = (values) => {
  const { voucheredOffer, voucherExpirationDays } = values.awardVouchers;

  const expirationDays = values.awardVouchers.isEnabled ? voucherExpirationDays : undefined;
  const awardInput = awardInputCreator.createAwardVouchers(voucheredOffer.id, expirationDays);

  return earningMechanismInputCreator.createPointSpend(
    values.pointSpend.pointCost,
    awardInput.awardVouchers,
    values.isOfferReturnable,
    values.pointSpend.allowedForNewMember,
  );
};

export const getEarningMechanismOperations = (
  offerId: string,
  values: Pick<ConfigureFormValues, 'pointSpend' | 'awardVouchers' | 'isOfferReturnable'>,
  dirtyFields: DirtyFieldsType,
): Operation[] => {
  const operations: Operation[] = [];

  if (
    !isFieldDirty<ConfigureFormValues>(dirtyFields, 'pointSpend') &&
    !isFieldDirty<ConfigureFormValues>(dirtyFields, 'awardVouchers') &&
    !isFieldDirty<ConfigureFormValues>(dirtyFields, 'isOfferReturnable')
  ) {
    return [];
  }

  if (values.pointSpend?.id) {
    operations.push(makeDeleteOperation('earningMechanismDelete', values.pointSpend.id));
  }

  const configuration = getPointSpendCreateInput(values);
  operations.push(makeEarningMechanismCreateOperation(offerId, configuration));

  return operations;
};
